export enum Role {
  ADMIN = 'admin',
  DISPATCHER = 'dispatcher',
  FLEET_MANAGER = 'fleetManager',
  FLEET_USER = 'fleet_user',
  DRIVER = 'driver',
  UNKNOWN = 'unknown',
}
